import { Phone } from "lucide-react";
import { Button } from "./ui/button";
import { useAnalytics } from "@/hooks/useAnalytics";

const MobileBottomBar = () => {
  const { trackPhoneClick } = useAnalytics();
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-4 bg-white/95 backdrop-blur-lg border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
      <a 
        href="tel:+420732658712" 
        className="block"
        onClick={() => trackPhoneClick('+420732658712')}
      >
        <Button variant="electric" size="xl" className="w-full gap-3">
          <Phone className="h-6 w-6" />
          <span className="text-lg font-bold">Zavolat ihned</span>
        </Button>
      </a>
    </div>
  );
};

export default MobileBottomBar;